import $ from 'jquery';
import { standardizeHeights } from '../../core/INF-gridAlignment';

const Blog = () => {
  if ($('[data-section-type="INF-Blog"]').length === 0) {
    return;
  }

  const grid_item_selector = '[data-article-tile]';
  const child_selectors = [
    '[data-article-tile-image]',
    '[data-article-tile-title]',
    '[data-article-tile-excerpt]',
  ];
  
  $(window).on('resize', () => {
    standardizeHeights(grid_item_selector, child_selectors);
  });
};

export { Blog };